import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/components/PalmatePopupLoader.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/scss/globals.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/assets/scss/fonts.css");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/script.js");
